import React from "react";
import { EventProps } from "react-big-calendar";
import BookingEvent from "./BookingEvent";

const CustomEvent: React.FC<EventProps<BookingEvent>> = ({ event }) => {
  const { title, user } = event.booking;
  const userName =
    user && typeof user === "object"
      ? `${(user as any).firstname} ${(user as any).lastname}`
      : null;

  return (
    <div>
      {userName && (
        <div
          style={{ fontSize: "0.8em", marginTop: "2px", marginBottom: "8px" }}
        >
          {userName}
        </div>
      )}
      <div
        style={{
          fontSize: "1em",
          fontWeight: "bold",
          textTransform: "capitalize",
        }}
      >
        {title}
      </div>
    </div>
  );
};

export default CustomEvent;
